// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"68080ea2","453":"cb7cca9c","455":"1c9c6629","977":"1dd20e82"}[chunkId] + ".chunk.js";
};